import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const ConfirmCode = ({ setConfirmCode, codeToConfirm }) => {
  const [codeClientConfirm, setCodeClientConfirm] = useState('');
  const [showBadCode, setShowBadCode] = useState(false);
  
  const handleChange = (e)=>{
    e.preventDefault();
    setCodeClientConfirm(e.target.value);
    //console.log('codigo tecleado',e.target.value);
  }
  const handleConfirm = (e)=>{
    e.preventDefault();
    //console.log('Codigo grabado en codeClientConfirm:',codeClientConfirm);
    codeClientConfirm!==codeToConfirm?setShowBadCode(true):setShowBadCode(false);
    if(codeClientConfirm==='') handleConfirm();
    else {
      //console.log('Almacenando codigo a confirmar...');
      setConfirmCode(codeClientConfirm)
    };
  }
  return (
    <div className="w-50 ms-auto me-auto pt-3 pb-3">
        <Form.Group className="mb-3" controlId="formGridConfirmCode">
          <Form.Label>Confirmar Código</Form.Label>
          <Form.Control value={codeClientConfirm} onChange={handleChange} type='text' placeholder="ingresar código" />
        </Form.Group>
        <Button onClick={handleConfirm}>Confirmar</Button>
        <p className="text-secondary mt-2">El código de confirmación fue enviado a tu e-mail</p>
        {showBadCode&&<h4 className="text-danger fs-6 text-center mt-4">Codigo incorrecto...</h4>}
    </div>
  );
};

export default ConfirmCode;
